@let vm = toastMessageRef.vm;
<div
  class="flex items-center gap-4 p-4 rounded-radius-container bg-status-success-30 text-xs text-left drop-shadow-foreground-primary-100-shadow-30 dark:drop-shadow-foreground-secondary-100-shadow-30"
  [ngClass]="{
    'bg-status-success-30': vm.type === ToastMessageType.Success,
    'bg-status-info-30': vm.type === ToastMessageType.Info,
    'bg-status-warning-30': vm.type === ToastMessageType.Warning,
    'bg-status-error-30': vm.type === ToastMessageType.Error,
  }"
>
  @switch (vm.type) {
    @case (ToastMessageType.Success) {
      <svg-icon [key]="vm.icon ?? 'ready-24'" size="32" class="shrink-0 text-status-success-text" />
    }
    @case (ToastMessageType.Info) {
      <svg-icon [key]="vm.icon ?? 'info-16'" size="32" class="shrink-0 text-status-info-text" />
    }
    @case (ToastMessageType.Warning) {
      <svg-icon [key]="vm.icon ?? 'warning-16'" size="32" class="shrink-0 text-status-warning-text" />
    }
    @case (ToastMessageType.Error) {
      <svg-icon [key]="vm.icon ?? 'faulted-16'" size="32" class="shrink-0 text-status-error-text" />
    }
  }
  <div class="grow">
    {{ vm.message$ | async }}
  </div>
  @if (vm.closeable) {
    <button type="button" class="self-start shrink-0 flex justify-center items-center" (click)="onCloseClick()">
      <svg-icon key="close-16" size="20"></svg-icon>
    </button>
  }
</div>
